module.exports = __webpack_public_path__ + "static/img/home_invite_card.aa5092a1.png";